import { getWindowLocationOrigin } from '../../utils/window'
import { generateMetaTags } from '../../utils/helmet'

const title = 'Prospect Viewer | IrisVR'
const description =
  'Download Prospect Viewer to join VR meetings and walkthroughs led by licensed Prospect users. Compatible with Windows devices.'
const url = `${getWindowLocationOrigin()}/prospect-viewer`
const image =
  'https://s3.amazonaws.com/iris-opengraph-images/ImgTag_Prospect.jpg'
const imageWidth = 1200
const imageHeight = 697

export default generateMetaTags({
  title,
  description,
  image,
  url,
  imageWidth,
  imageHeight,
})
